//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      stepLoading: false,
      form: null
    };
  },
  methods: {
    handleStepOk: function handleStepOk() {
      var _this = this;

      var vm = this;
      this.stepLoading = true;
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log('values', values);
          setTimeout(function () {
            vm.stepLoading = false;
            vm.$emit('success', {
              values: values
            });
          }, 2000);
          return;
        }

        _this.stepLoading = false;

        _this.$emit('error', {
          err: err
        });
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
      this.$emit('cancel');
    },
    onForgeStepCode: function onForgeStepCode() {}
  }
};